import { createReducer } from "shared/utils/redux.utils";
import { generalAppSettingStateHandlers } from "./appsetting.handlers";
import { GeneralAppSettingAction } from "./appsettings.actions";
import { GeneralAppSettingState } from "./appsettings.state.types";

export const generalAppSettingStateReducer = createReducer<
  GeneralAppSettingState,
  typeof GeneralAppSettingAction
>(generalAppSettingStateHandlers);